import { QuotationUnit } from 'data-layer-cr/dist/models';

interface ChipPlan {
  title: string;
  colorText: string;
  colorBackground: string;
}

const packageOptions = {
  premium: 0,
  economy: 1,
  flexible: 2,
  lastOption: 3,
};

const packageOptionsIds = {
  premium: 3,
  economy: 2,
  flexible: 1,
};

export const packageOptionsDescription = {
  '₡': {
    premium: 'INDIVIDUALCOLONES-PREMIUM',
    economy: 'INDIVIDUALCOLONES-ECONOMY',
    flexible: 'INDCOLONESPX-BASE',
  },
  $: {
    premium: 'INDIVIDUALDOLLAR-PREMIUMPX',
    economy: 'INDIVIDUALDOLLAR-ECONOMYPX',
    flexible: 'INDDOLLARPX-BASE',
  },
};

export enum EnumTypeOfQuotation {
  old = 'old',
  current = 'current',
  new = 'new',
}
interface ITypeOfQuotation {
  titles: string[];
  packageOptions?: Record<number, string[]>;
}
const coverages = ['0004', '0005'];

export const typeOfQuotation: Record<EnumTypeOfQuotation, ITypeOfQuotation> = {
  [EnumTypeOfQuotation.old]: {
    titles: ['Plan Premium', 'Plan Economy', 'Plan Flexible'],
    packageOptions: {
      [packageOptions.lastOption]: coverages,
      [packageOptions.flexible]: [...coverages, '0002'],
    },
  },
  [EnumTypeOfQuotation.current]: {
    titles: ['Plan Platino', 'Plan Dorado', 'Plan Económico'],
    packageOptions: {
      [packageOptions.lastOption]: coverages,
    },
  },
  [EnumTypeOfQuotation.new]: {
    titles: ['Plan Platino', 'Plan Dorado', 'Plan Económico'],
  },
};

const dateStartNewQuotation = process.env
  .REACT_APP_DATE_START_NEW_QUOTATION as string;
const dateEndNewQuotation = process.env
  .REACT_APP_DATE_END_NEW_QUOTATION as string;

export const getTypeOfQuotation = (createdAt?: string): EnumTypeOfQuotation => {
  const startNow = new Date(dateStartNewQuotation).getTime();
  const endNow = new Date(dateEndNewQuotation).getTime();
  const dateCreated = new Date(createdAt ?? new Date()).getTime();
  if (dateCreated < startNow) {
    return EnumTypeOfQuotation.old;
  }
  if (dateCreated > startNow && dateCreated < endNow) {
    return EnumTypeOfQuotation.current;
  }
  return EnumTypeOfQuotation.new;
};

export function getChipPlanByOption(option: number): ChipPlan {
  if (option === packageOptionsIds.premium) {
    return {
      title: 'Máxima protección',
      colorText: '#0C472C',
      colorBackground: '#E8FBF3',
    };
  }
  if (option === packageOptionsIds.economy) {
    return {
      title: 'Beneficios básicos',
      colorText: '#623601',
      colorBackground: '#FFEFD0',
    };
  }
  return {
    title: 'Coberturas a tu medida',
    colorText: '#4A4B4E',
    colorBackground: '#EAEAEA',
  };
}

export function getChipPlanByOptionDescription(
  option: string,
  moneyType: string,
): ChipPlan {
  const options = packageOptionsDescription[moneyType as '₡' | '$'];

  if (option === options.economy) {
    return {
      title: 'Beneficios básicos',
      colorText: '#623601',
      colorBackground: '#FFEFD0',
    };
  }
  if (option === options.premium) {
    return {
      title: 'Máxima protección',
      colorText: '#0C472C',
      colorBackground: '#E8FBF3',
    };
  }
  return {
    title: 'Coberturas a tu medida',
    colorText: '#4A4B4E',
    colorBackground: '#EAEAEA',
  };
}

export function getTitleByOption(option: number, createdAt?: string): string {
  const newQuotation = getTypeOfQuotation(createdAt);
  const { titles } = typeOfQuotation[newQuotation];
  if (option === packageOptionsIds.premium) {
    return titles[0];
  }
  if (option === packageOptionsIds.economy) {
    return titles[1];
  }
  return titles[2];
}

export function getTitleByOptionByPlanDescription(
  option: string,
  moneyType: string,
): string {
  const options = packageOptionsDescription[moneyType as '₡' | '$'];
  if (option === options.premium) {
    return 'PLATINO';
  }
  if (option === options.economy) {
    return 'DORADO';
  }
  return 'ECONÓMICO';
}

export function isPremiumOption(
  units: QuotationUnit[],
  currentIndex: number,
): boolean {
  const maxPrice = Math.max(...units.map((unit) => unit.total.grandTotal));
  const firstMaxIndex = units.findIndex(
    (unit) => unit.total.grandTotal === maxPrice,
  );

  return currentIndex === firstMaxIndex;
}

export function isFlexibleOption(option: number): boolean {
  return option === packageOptions.flexible;
}

export function isFlexibleOptionSelected(
  option: string,
  moneyType: string,
): boolean {
  const options = packageOptionsDescription[moneyType as '₡' | '$'];
  return option === options.flexible;
}
